import { Size } from './modal.types';

export const FALLBACK_REMOVE_TIMEOUT_MS = 250;

export const IS_ANIMATING = 'is-animating';

export const SIZES: Record<Size, any> = {
  s: {
    'start-col-mq4': '4',
    'start-col-mq5': '5',
    mq1: '12',
    mq4: '6',
    mq5: '4',
  },
  m: {
    'start-col-mq4': '3',
    'start-col-mq5': '4',
    mq1: '12',
    mq4: '8',
    mq5: '6',
  },
  l: {
    'start-col-mq5': '2',
    mq1: '12',
    mq5: '10',
  },
  xl: {
    mq1: '12',
  },
};
